import { render, staticRenderFns } from "./TeamsIcon.vue?vue&type=template&id=5ce2f12e&"
import script from "./TeamsIcon.vue?vue&type=script&lang=ts&"
export * from "./TeamsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports